module.exports = __webpack_public_path__ + "static/dgsp-mobile-ca1da023246431501e1411c33e180c8d.jpg";